export class Subscriber {
    constructor(id, version, ownWindow, origin, topic) {
        this.id = id;
        this.version = version;
        this.ownWindow = ownWindow;
        this.origin = origin;
        this.topic = topic;
    }
}
//# sourceMappingURL=subscriber.js.map